import {ReactNode} from 'react';
import * as styles from './warningPopup.module.css';

interface IWarningPopupProps {
    topText: Iterable<ReactNode>,
    buttons: ReactNode,
}

const WarningPopup = ({topText, buttons}: IWarningPopupProps) => (
    <div className={styles.screenCover}>
        <div className={styles.window}>
            <div className={styles.topText}>
                {topText}
            </div>
            <div className={styles.buttons}>
                {buttons}
            </div>
        </div>
    </div>
);

export default WarningPopup;
